import { SwapPanel, SwapPanelProps } from '../components/SwapPanel'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { Info } from '@/ui/molecules/info/Info'

export function SwapView(props: SwapPanelProps) {
  return (
    <PageLayout>
      <h1 className="typography-heading-1 flex items-center gap-1">
        Swap
        <Info className="mt-2 sm:mt-3">
          Swap between stablecoins without fees and slippage.{' '}
          <ExternalLink to={links.docs.swap} variant="secondary">
            Learn more
          </ExternalLink>
        </Info>
      </h1>
      <SwapPanel {...props} className="mx-auto w-full max-w-2xl" />
    </PageLayout>
  )
}
